<template>
  <div class="error-404">
    <img src="~/assets/images/404.png" alt="">
    <p>{{ msg }}</p>
  </div>
</template>
<script>
export default {
  props: {
    msg: String
  },
}
</script>

<style lang="scss" type="text/scss">
.error-404 {
  padding: 110px 0;
}

.error-404 img {
  display: block;
  width: 170px;
  height: auto;
  margin: 0 auto;
}

.error-404 p {
  margin-top: 16px;
  font-weight: 500;
  font-size: 15px;
  color: #999999;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// components/Error404.vue